import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {Workout} from '../../domain/workout';
import type {
  RemoveExerciseFromWorkoutInput,
  WorkoutRepository,
} from '../ports/workout.repository';

export class RemoveExerciseFromWorkout
  implements UseCase<[RemoveExerciseFromWorkoutInput], Workout>
{
  constructor(private readonly repository: WorkoutRepository) {}

  execute(input: RemoveExerciseFromWorkoutInput): Promise<Result<Workout, WorkoutError>> {
    return this.repository.removeExercise(input);
  }
}
